import ReceiptIcon from '@mui/icons-material/Receipt';
import classes from "./integrationStyles.module.scss"
import { Col, Row } from 'react-bootstrap';
import Button from '../UI/Button';
const ActiveInvoice = ({invoiceId, onCreateNew, ...props})=>{
    return(<>
    <div className={`${classes["container"]}`} {...props} >
        <Row>
            <Col className="col-1"><ReceiptIcon/></Col>
            <Col style={{textAlign:"left"}}>
                Currently editing invoice: 
                <span id="activeInvoice" className={classes["invoice-id"]}>{invoiceId}</span>
            </Col>
            <Col className="col-2">
                <Button id="activeInvoiceBtn" onClick={onCreateNew}>Create new</Button>
            </Col>
        </Row>
    </div>
    </>)
}
export default ActiveInvoice;